import { useEffect, useRef, useState, RefObject } from 'react';

interface UseConditionalStickyReturn {
  mainCellRef: RefObject<HTMLDivElement>;
  sideCellRef: RefObject<HTMLDivElement>;
  shouldStick: boolean;
}

export const useConditionalSticky = (
  mainContent: React.ReactNode,
  sideContent: React.ReactNode
): UseConditionalStickyReturn => {
  const mainCellRef = useRef<HTMLDivElement>(null);
  const sideCellRef = useRef<HTMLDivElement>(null);
  const [shouldStick, setShouldStick] = useState(false);

  useEffect(() => {
    const mainCell = mainCellRef.current;
    const sideCell = sideCellRef.current;

    if (!mainCell || !sideCell) return;

    const checkHeights = () => {
      const mainHeight = mainCell.scrollHeight;
      const sideHeight = sideCell.scrollHeight;
      setShouldStick(sideHeight < mainHeight);
    };

    // Initial check
    checkHeights();

    // Use ResizeObserver to watch for size changes
    const resizeObserver = new ResizeObserver(() => {
      checkHeights();
    });

    resizeObserver.observe(mainCell);
    resizeObserver.observe(sideCell);

    return () => {
      resizeObserver.disconnect();
    };
  }, [mainContent, sideContent]);

  return {
    mainCellRef,
    sideCellRef,
    shouldStick,
  };
};
